import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Sparkles } from 'lucide-react';
import axios from 'axios';

// Intercepts 402 Payment Required responses from the API and shows an upgrade modal
// with a clear "Upgrade Now" / "Maybe Later" choice instead of an opaque toast.
export default function UpgradePromptModal() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const id = axios.interceptors.response.use(
      (res) => res,
      (err) => {
        if (err?.response?.status === 402) {
          const detail = err.response.data?.detail || 'You\'ve hit your plan limit.';
          setMessage(detail);
          setOpen(true);
        }
        return Promise.reject(err);
      }
    );
    return () => axios.interceptors.response.eject(id);
  }, []);

  const upgrade = () => {
    setOpen(false);
    navigate('/pricing');
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-sm rounded-3xl" data-testid="upgrade-prompt-modal">
        <div className="text-center py-2 space-y-4">
          <div className="mx-auto w-14 h-14 rounded-2xl bg-teal-50 flex items-center justify-center">
            <Sparkles className="w-7 h-7 text-teal-600" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-stone-900 mb-2">You've hit your free plan limit</h2>
            <p className="text-sm text-stone-600 leading-relaxed">{message}</p>
          </div>
          <div className="flex flex-col gap-2 pt-2">
            <Button
              onClick={upgrade}
              className="w-full h-11 bg-teal-600 hover:bg-teal-700 text-white rounded-full font-medium"
              data-testid="upgrade-now-btn"
            >
              Upgrade Now
            </Button>
            <Button
              variant="ghost"
              onClick={() => setOpen(false)}
              className="w-full h-11 text-stone-600 rounded-full"
              data-testid="upgrade-later-btn"
            >
              Maybe Later
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
